import React, { Fragment, useState, useEffect } from "react";
import {
  Container,
  Heading,
  Subheading,
  FormContainer,
  FormControl,
  StyledLabel,
  CheckBoxLabel,
  CheckboxContainer,
  CheckboxFormControl,
  Row,
  BackArrow,
  HyperLink,
  OuterContainer,
} from "./Styles";
import { CustomRadioGroup, CustomCheckbox } from "../../common/FormInputs";
import ActionBar from "../../common/ActionBar";
import { navigate, useLocation } from "@reach/router";
import _ from "lodash";
import { FieldArray, Formik } from "formik";
import FormField from "../../common/FormField/FormField";
import {
  PrimaryOutlinedCTAButton,
  PrimaryCTAButton,
  SecondaryCTAButton,
} from "../../common/Buttons";
import CaseService from "../../../services/CaseService";
import styled from "styled-components";
import { CreateCaseStep2Schema } from "../../../helpers/validationSchema";
import useLoader from "../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../../helpers/functions";
import useAlert from "../../../hooks/useAlert";
import theme from "../../../assets/theme";
import useCartCount from "../../../hooks/useCartCount";
import AlertDialog from "../../common/Alert";
import COLORS from "../../../assets/Colors";
import { setPostPayload } from "../CreateCase/function";
import useUser from "../../../hooks/useUser";
// import CartService from "../../../services/CartService";
// import { addCartItems } from "../CaseCart/functions";

const inputs = [
  {
    name: "respondentName",
    type: "text",
    label: "Name of the Respondent",
    required: true,
    textTransform: "Capitalize",
  },
  {
    name: "respondentEmail",
    type: "email",
    label: "Email of the Respondent",
    required: true,
  },
  {
    name: "respondentMobile",
    type: "text",
    label: "Phone Number of the Respondent",
    required: true
  },
  {
    name: "respondentAddress",
    type: "text",
    label: "Address of the Respondent",
    required: true
  },
];

const Index = ({ caseId }) => {
  const [caseObj, setCaseObj] = useState({});
  const breadcrumbs = ["My Cases", "Create New Case"];
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const { hideAlert, showAlert } = useAlert();
  const { setTriggerCount } = useCartCount();
  const { authSetting } = useUser();
  const [dialogData, setDialogData] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    async function getCase(caseId) {
      try {
        setLoader({ state: true });
        const response = await CaseService.getCase(caseId);
        if (response) {
          setCaseObj(response);
        }
      } catch (error) {
        const message = getErrorMessage(error);
        enqueueSnackbar(message, {
          variant: "error",
        });
      } finally {
        setLoader({ state: false });
      }
    }
    if (caseId) {
      getCase(caseId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [caseId]);

  const onBreadcrumbClick = (selected) => {
    switch (_.snakeCase(selected)) {
      case "my_cases":
        navigate("/dashboard/cases");
        break;
      default:
        break;
    }
  };

  /* async function validatePayment(payload) {
    if (payload?.paymentCode) {
      const paymentCodeValidate = await CaseService.validatePaymentCode(
        caseId,
        payload?.paymentCode,
      );
      return paymentCodeValidate["paymentCodeValidation"];
    } else return false;
  } */

  async function addToCart(payload) {
    setLoader({ state: true, message: "Submitting form..." });
    try {
      // const paymentCodeValidate = await validatePayment(payload);
      /* if (paymentCodeValidate) {
        const response = await CaseService.submitCase(
          payload,
          caseId,
          caseObj.claimantParty.id,
        );
        if (response) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          navigate("/dashboard/cases");
        }
      } else if (!paymentCodeValidate) { */
        let negotiationSuccessFee;
        const registrationFee =
          (
            await CaseService.getCase(
              caseId,
              "?estimateFeeKind=registrationFee",
            )
          )?.fee || {};
        if (caseObj?.subscriptionKind !== "adhoc") {
          negotiationSuccessFee =
            (await CaseService.getCase(caseId, "?estimateFeeKind=successFee"))
              ?.fee || {};
        }
        showAlert({
          heading: "Payment Information",
          desc: (
            <PaymentAlert
              {...{ registrationFee, negotiationSuccessFee, caseObj, payload }}
            />
          ),

          primaryBtnText: "Add to Payments",
          // secondaryBtnPrimaryText: "Confirm & Generate Proforma",
          secondaryBtnText: "Cancel",
          // clickSecondaryPrimarybtn: () => {
          //   generateProforma(payload);
          // },
          clickSecondarybtn: () => {
            hideAlert();
          },
          clickPrimaryBtn: () => submitMediationCase(payload),
          isOpen: true,
          onDialogClose: () => {
            hideAlert();
          },
          descriptionTextStyle: {
            textAlign: "left",
          },
        });
      // }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  async function addToCartEditCase(payload) {
    setLoader({ state: true, message: "Submitting form..." });
    try {
      // const paymentCodeValidate = await validatePayment(payload);
      /* if (paymentCodeValidate) {
        const response = await CaseService.editCase(caseId, payload);
        if (response) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          navigate("/dashboard/cases");
        }
      } else if (!paymentCodeValidate) { */
        let negotiationSuccessFee;
        const registrationFee =
          (
            await CaseService.getCase(
              caseId,
              "?estimateFeeKind=registrationFee",
            )
          )?.fee || {};
        if (caseObj?.subscriptionKind !== "adhoc") {
          negotiationSuccessFee =
            (await CaseService.getCase(caseId, "?estimateFeeKind=successFee"))
              ?.fee || {};
        }
        showAlert({
          heading: "Payment Information",
          desc: (
            <PaymentAlert
              {...{
                registrationFee,
                negotiationSuccessFee,
                caseObj,
                payload,
              }}
              editFlag={location?.state?.editFlag}
            />
          ),

          primaryBtnText: location?.state?.editFlag ? "Submit" : "Add to Cart",
          secondaryBtnText: "Cancel",
          clickSecondarybtn: () => {
            hideAlert();
          },
          clickPrimaryBtn: () => submitMediationCase(payload),
          isOpen: true,
          onDialogClose: () => {
            hideAlert();
          },
          descriptionTextStyle: {
            textAlign: "left",
          },
        });
      // }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  async function submitMediationCase(payload) {
    try {
      setLoader({ state: true, message: "Submitting form..." });
      if (location?.state?.editFlag) {
        delete payload.title;
        const response = await CaseService.editCase(caseId, payload);
        if (response) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          navigate("/dashboard/cases?caseType=arbitration");
        }
      } else {
        const response = await CaseService.submitCase(
          payload,
          caseId,
          caseObj.claimantParty.id,
        );
        if (response) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          navigate("/dashboard/cart");
        }
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
      hideAlert();
    } finally {
      setTriggerCount(true);
      setLoader({ state: false });
      hideAlert();
    }
  }

  /* const generateProforma = async (payload) => {
    try {
      setLoader({ state: true, message: "Generating Invoice..." });
      let newly_added_cases = [];
      newly_added_cases = [caseObj];
      await CaseService.submitCase(
        { ...payload },
        caseId,
        caseObj.claimantParty.id,
      );
      await addCartItems(newly_added_cases, "caseRegistration");
      const result = await CartService.generatePerforma();
      if (result?.status === "proformaGenerated") {
        enqueueSnackbar("Profoma invoice is generated Successfully", {
          variant: "success",
        });
        navigate("/dashboard/payments");
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      hideAlert();
    }
  }; */

  async function saveAsDraftOrSubmit(values, isDraft) {
    const postData = JSON.parse(JSON.stringify(values));
    try {
      setLoader({ state: true, message: "Submitting form..." });
      const response = await CaseService.updateDraft(
        postData,
        caseId,
        caseObj.claimantParty?.id,
      );
      if (response?.case?.id) {
        if (isDraft) {
          enqueueSnackbar("Case added to draft successfully", {
            variant: "success",
          });
          navigate(
            `/dashboard/cases?caseType=${response?.case?.resolutionKind}`,
          );
        } else {
          navigate(
            `/dashboard/cases/create/${response.case.id}/step-3?caseType=${response?.case?.resolutionKind}`,
          );
        }
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  function onFormSubmit(values, props, isDraft = false) {
    try {
      const postData = JSON.parse(JSON.stringify(values));
      postData.respondentParties = postData?.respondentParties?.map((el) => {
        return {
          respondentKind: el?.respondentKind,
          name: el?.respondentName,
          email: el?.respondentEmail.toString().toLowerCase(),
          mobile: el?.respondentMobile,
          address: el?.respondentAddress,
        };
      });
      const hasDuplication =
        postData?.respondentParties?.length &&
        postData?.respondentParties?.filter(
          (mediator, index) =>
            postData?.respondentParties?.findIndex(
              (el) => el?.email === mediator?.email,
            ) !== index,
        )?.length;
      if (hasDuplication) {
        // eslint-disable-next-line no-throw-literal
        throw "Duplicate email IDs found in respondent parties";
      }
      if (caseObj?.resolutionKind !== "negotiation" && !isDraft) {
        if (location?.state?.editFlag) {
          let payload = setPostPayload(location?.state?.values);
          const submitPayload = {
            ...postData,
            ...payload,
            agreement: values.agreement,
          };
          showAlert({
            heading: "Review Case Details",
            desc: <PaymentAlert {...{ caseObj, payload: submitPayload }} preview />,
            primaryBtnText: "OK",
            secondaryBtnText: "Cancel",
            clickSecondarybtn: () => hideAlert(),
            clickPrimaryBtn: () => {
              hideAlert();
              addToCartEditCase(submitPayload);
            },
            isOpen: true,
            onDialogClose: () => hideAlert(),
          });
        } else {
          showAlert({
            heading: "Review Case Details",
            desc: <PaymentAlert {...{ caseObj, payload: postData }} preview />,
            primaryBtnText: "OK",
            secondaryBtnText: "Cancel",
            clickSecondarybtn: () => hideAlert(),
            clickPrimaryBtn: () => {
              hideAlert();
              addToCart(postData);
            },
            isOpen: true,
            onDialogClose: () => hideAlert(),
          });
        }
      } else {
        saveAsDraftOrSubmit(postData, isDraft);
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    }
  }

  /**
   * @description Function to trigger the delete case
   * @param {*} param0
   */
  const deleteDraft = async (id) => {
    try {
      setLoader({ state: true, message: "Deleting Cases..." });
      const res = await CaseService.deleteDraftCase(id);
      if (res?.message) {
        enqueueSnackbar(res?.message, {
          variant: "success",
        });
        if (caseObj?.resolutionKind !== "negotiation") {
          navigate(`/dashboard/cases?caseType=${caseObj?.resolutionKind}`);
        } else {
          navigate("/dashboard/cases?caseType=negotiation");
        }
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      setOpen(false);
    }
  };

  /**
   * @description Function to show the delete warning
   * @param {*} id
   */
  const deleteWaring = (id) => {
    setOpen(true);
    setDialogData({
      primaryBtnText: "Proceed",
      secondaryBtnText: "Cancel",
      clickPrimaryBtn: () => deleteDraft(id),
      clickSecondarybtn: () => setOpen(false),
      onDialogClose: () => setOpen(false),
      desc: `Are you sure you want to delete this draft case?`,
      heading: "Delete Case",
      descriptionTextStyle: {
        textAlign: "center",
      },
    });
  };

  function setInitialValues(caseObj) {
    if (
      caseObj?.respondentParties &&
      caseObj?.respondentParties[0]?.respondentKind
    ) {
      return caseObj?.respondentParties?.map((el) => {
        return {
          respondentKind: el.respondentKind,
          respondentName: el?.name,
          respondentEmail: el?.email,
          respondentMobile: el?.mobile || "",
          respondentAddress: el?.address || "",
        };
      });
    } else {
      return [
        {
          respondentKind: caseObj?.respondentKind || "individual",
          respondentName: caseObj?.respondentName || "",
          respondentEmail: caseObj?.respondentEmail || "",
          respondentMobile: caseObj?.respondentMobile || "",
          respondentAddress: caseObj?.respondentAddress || "",
        },
      ];
    }
  }

  const dummyParty = {
    respondentKind: "individual",
    respondentName: "",
    respondentEmail: "",
    respondentMobile: "",
    respondentAddress: "",
  };

  return (
    <OuterContainer>
      <ActionBar {...{ breadcrumbs, onBreadcrumbClick }} />
      <Container className="CreateCase">
        <Heading>
          <div style={{ display: "flex", flex: 1 }}>
            <BackArrow
              onClick={() =>
                navigate(
                  `/dashboard/cases/create/${caseId}?caseType=${caseObj?.resolutionKind}`,
                )
              }
              src={require("../../../assets/images/backArrow.svg")}
            />
            Create New Case (2/{" "}
            {caseObj?.resolutionKind !== "negotiation" ? 2 : 3})
          </div>
          <div className="delete" onClick={() => deleteWaring(caseId)}>
            <img
              src={require("../../../assets/images/delete.svg")}
              alt="delete Icon"
            />
          </div>
        </Heading>
        <div>
          <Subheading style={{ marginBottom: "unset" }}>
            Enter Respondent Details
          </Subheading>
        </div>
        <Formik
          onSubmit={onFormSubmit}
          initialValues={{
            respondentParties: setInitialValues(caseObj),
            agreement: false,
          }}
          enableReinitialize
          validationSchema={CreateCaseStep2Schema}
          validateOnBlur
          validateOnChange
        >
          {({
            values,
            handleChange,
            errors,
            handleSubmit,
            touched,
            handleBlur,
            setFieldValue,
          }) => (
            <FormContainer onSubmit={handleSubmit}>
              <FieldArray
                name="respondentParties"
                render={({ push, remove }) => (
                  <>
                    {values?.respondentParties?.map((party, index) => (
                      <Fragment key={index}>
                        {values?.respondentParties?.length > 1 ? (
                          <div className="header-container">
                            <Subheading
                              style={{
                                marginBottom: 15,
                                display: "flex",
                                flex: 1,
                              }}
                            >
                              Respondent {index + 1}
                            </Subheading>
                            <div
                              className="removeIcon"
                              onClick={() => remove(index)}
                            >
                              <img
                                src={require("../../../assets/images/removeIcon.svg")}
                                alt="delete Icon"
                              />
                            </div>
                          </div>
                        ) : null}
                        <RespondentInputs
                          values={party}
                          errors={
                            errors && errors?.respondentParties
                              ? errors?.respondentParties[index]
                              : {}
                          }
                          touched={
                            touched && touched?.respondentParties
                              ? touched?.respondentParties[index]
                              : {}
                          }
                          {...{
                            index,
                            party,
                            handleBlur,
                            setFieldValue,
                          }}
                        />
                      </Fragment>
                    ))}
                    {caseObj?.resolutionKind !== "negotiation" ? (
                      <SecondaryCTAButton
                        onClick={() => {
                          push({ ...dummyParty });
                        }}
                        style={{
                          marginTop: "24px",
                          margin: "unset",
                        }}
                      >
                        + Add Another Respondent
                      </SecondaryCTAButton>
                    ) : null}
                  </>
                )}
              />
              {/* {caseObj.resolutionKind !== "negotiation" ? (
                <FormControl style={{ marginTop: "8px" }}>
                  <FormField
                    white
                    input={{
                      name: "paymentCode",
                      label: <TextColor>Payment Code (If any)</TextColor>,
                      type: "text",
                      required: false,
                    }}
                    {...{
                      errors,
                      touched,
                      values,
                      handleChange,
                      handleBlur,
                    }}
                  />
                </FormControl>
              ) : null} */}
              {caseObj?.subscriptionKind !== "adhoc" ? (
                <CheckboxFormControl>
                  <CheckboxContainer>
                    <CustomCheckbox
                      name="agreement"
                      checked={values.agreement}
                      onChange={handleChange}
                    />
                    <CheckBoxLabel>
                      I Agree to IAMC being my ADR provider and agree to{" "}
                      <HyperLink
                        onClick={() => {
                          window.open(
                            authSetting?.rulesDocumentUrl ||
                              "https://justact-api-uploads.s3.ap-south-1.amazonaws.com/13/1620883614227-f4dbb5a2-4d9c-4a80-8645-b3500816dead/JustAct_Rules.pdf",
                          );
                        }}
                      >
                        IAMC Rules
                      </HyperLink>{" "}
                      of Negotiation, Mediation, Arbitration, as applicable.
                    </CheckBoxLabel>
                  </CheckboxContainer>
                </CheckboxFormControl>
              ) : null}
              <FormControl>
                {location?.state?.editFlag ? (
                  <Row>
                    <PrimaryOutlinedCTAButton
                      type="button"
                      onClick={() =>
                        navigate(
                          `/dashboard/cases/create/${caseId}?caseType=arbitration`,
                        )
                      }
                      style={{ width: "47%" }}
                    >
                      Back
                    </PrimaryOutlinedCTAButton>
                    <PrimaryCTAButton
                      disabled={
                        !values.agreement &&
                        caseObj?.subscriptionKind !== "adhoc"
                      }
                      onClick={handleSubmit}
                      style={{ width: "47%" }}
                    >
                      Proceed
                    </PrimaryCTAButton>
                  </Row>
                ) : (
                  <Row>
                    <PrimaryOutlinedCTAButton
                      type="button"
                      onClick={() => onFormSubmit(values, null, true)}
                      style={{ width: "47%" }}
                    >
                      Save as Draft
                    </PrimaryOutlinedCTAButton>
                    <PrimaryCTAButton
                      disabled={
                        !values.agreement &&
                        caseObj?.subscriptionKind !== "adhoc"
                      }
                      onClick={handleSubmit}
                      style={{ width: "47%" }}
                    >
                      {caseObj?.resolutionKind !== "negotiation"
                        ? "Submit"
                        : "Proceed"}
                    </PrimaryCTAButton>
                  </Row>
                )}
              </FormControl>
            </FormContainer>
          )}
        </Formik>
      </Container>
      <AlertDialog isOpen={open} {...{ ...dialogData }} />
    </OuterContainer>
  );
};

export default Index;

const RespondentInputs = ({
  index,
  values,
  errors,
  touched,
  handleBlur,
  setFieldValue,
}) => {
  return (
    <div key={index}>
      <FormControl style={{ marginBottom: 32 }}>
        <StyledLabel>Respondent Is</StyledLabel>
        <CustomRadioGroup
          radioInputs={[
            { label: "Individual", value: "individual" },
            { label: "Organization", value: "organization" },
          ]}
          name={`respondentKind`}
          values={values}
          handleChange={(e) =>
            setFieldValue(
              `respondentParties[${index}].respondentKind`,
              e?.target?.value,
            )
          }
        />
      </FormControl>
      {inputs.map((input, key) => (
        <FormControl
          key={key}
          className={input.type === "number" ? "disabledArrows" : null}
        >
          <FormField
            white
            errors={errors || {}}
            touched={touched || {}}
            {...{
              input,
              values,
              handleBlur,
            }}
            handleChange={(e) => {
              if (input.name === "respondentMobile") {
                if (e?.target?.value?.match(/^[0-9]*$/)) {
                  setFieldValue(
                    `respondentParties[${index}].${input?.name}`,
                    e?.target?.value,
                  );
                }
              } else
                setFieldValue(
                  `respondentParties[${index}].${input?.name}`,
                  e?.target?.value,
                );
            }}
          />
        </FormControl>
      ))}
    </div>
  );
};

const PaymentAlert = ({
  registrationFee,
  negotiationSuccessFee,
  caseObj,
  payload,
  editFlag,
  preview,
}) => {
  const currentPayload = payload || caseObj || {};
  const respondentList =
    currentPayload?.respondentParties?.length
      ? currentPayload.respondentParties
      : caseObj?.respondentParties || [];
  const mediatorList =
    currentPayload?.requestedMediators?.length
      ? currentPayload.requestedMediators
      : caseObj?.requestedMediators || [];
  const disputeValue =
    currentPayload?.natureOfDispute === "others"
      ? currentPayload?.natureOfDisputeOther || "-"
      : currentPayload?.natureOfDispute || caseObj?.natureOfDispute || "-";
  const claimantName =
    currentPayload?.claimantParty?.name ||
    caseObj?.claimantParty?.name ||
    currentPayload?.claimantName ||
    "-";
  const preferredLanguage =
    currentPayload?.preferredLanguage === "others"
      ? currentPayload?.preferredLanguageOther || "-"
      : currentPayload?.preferredLanguage || caseObj?.preferredLanguage || "-";

  return (
    <UnorderList>
      {preview && (
        <>
          <li>
            <div className="data-row">
              <div className="data-field">
                <div className="label">Resolution Type</div>
                <div className="value">
                  {currentPayload?.resolutionKind || caseObj?.resolutionKind || "-"}
                </div>
              </div>
              <div className="data-field">
                <div className="label">Currency</div>
                <div className="value">
                  {currentPayload?.currencyUnit || caseObj?.currencyUnit || "-"}
                </div>
              </div>
            </div>
            <div className="data-row">
              <div className="data-field">
                <div className="label">Claim Value</div>
                <div className="value">
                  {currentPayload?.totalClaimValue ?? caseObj?.totalClaimValue ?? "-"}
                </div>
              </div>
              <div className="data-field">
                <div className="label">Preferred Language</div>
                <div className="value">{preferredLanguage}</div>
              </div>
            </div>
            <div className="data-row">
              <div className="data-field">
                <div className="label">Claimant Details</div>
                <div className="value">{claimantName}</div>
              </div>
              <div className="data-field">
                <div className="label">Nature of Dispute</div>
                <div className="value">{disputeValue}</div>
              </div>
            </div>
            <div className="data-row">
              <div className="data-field">
                <div className="label">Case Description</div>
                <div className="value">
                  {currentPayload?.description || caseObj?.description || "-"}
                </div>
              </div>
              <div className="data-field">
                <div className="label">Special Requirements</div>
                <div className="value">
                  {currentPayload?.specialRequirements ||
                    caseObj?.specialRequirements ||
                    "-"}
                </div>
              </div>
            </div>
          </li>
          <li>
            <div>Arbitrator / Mediator Details</div>
            {mediatorList?.map((mediator, index) => (
              <div key={index}>
                <div className="data-row">
                  <div className="data-field">
                    <div className="label">Name</div>
                    <div className="value">
                      {mediator?.mediatorName || mediator?.name || "-"}
                    </div>
                  </div>
                  <div className="data-field">
                    <div className="label">Email</div>
                    <div className="value">
                      {mediator?.mediatorEmail || mediator?.email || "-"}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </li>
          <li>
            <div>Respondent Details</div>
            {respondentList?.map((respondent, index) => (
              <div key={index}>
                <div className="data-row">
                  <div className="data-field">
                    <div className="label">Name</div>
                    <div className="value">
                      {respondent?.name || respondent?.respondentName || "-"}
                    </div>
                  </div>
                  <div className="data-field">
                    <div className="label">Email</div>
                    <div className="value">
                      {respondent?.email || respondent?.respondentEmail || "-"}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </li>
        </>
      )}
      {/* <li>
        <div>Respondent(s)</div>
        {payload?.respondentParties?.map((el, index) => (
          <div key={index}>
            <div className="data-row">
              <div className="data-field">
                <div className="label">Name</div>
                <div className="value">{el?.name}</div>
              </div>
              <div className="data-field">
                <div className="label">Email</div>
                <div className="value">{el?.email}</div>
              </div>
            </div>
          </div>
        ))}
      </li> */}
      {caseObj?.subscriptionKind === "adhoc" ? (
        <li>
          <b>
            You will be charged a non-refundable license fee of{" "}
            {registrationFee?.unit}{" "}
            {parseFloat(registrationFee?.total).toFixed(2) || 0.0} for using
            IAMC. The license validity is {registrationFee?.roomValidity}{" "}
            months.
          </b>
        </li>
      ) : (
        <>
          {editFlag !== 1 && (
            <li>
              {caseObj?.resolutionKind === "arbitration"
                ? "Case filing"
                : "Registration"}{" "}
              Fee -{" "}
              <b
                style={{
                  fontFamily: `${theme.fonts.primaryFontExtraBold}`,
                }}
              >
                {registrationFee?.unit}{" "}
                {parseFloat(registrationFee?.total).toFixed(2) || 0.0}
              </b>
            </li>
          )}
          {/* {caseObj?.resolutionKind === "arbitration" && (
            <li>
              Potential Arbitration Fee is{" "}
              <b
                style={{
                  fontFamily: `${theme.fonts.primaryFontExtraBold}`,
                }}
              >
                {registrationFee?.unit}{" "}
                {parseFloat(registrationFee?.potentialCost).toFixed(2) || 0.0}
              </b>
            </li>
          )} */}
          {caseObj?.resolutionKind !== "arbitration" && (
            <TextAlign>
              {/* (The{" "}
              {caseObj?.resolutionKind === "arbitration"
                ? "Arbitration"
                : "Registration"}{" "}
              Fee will be added to the cart) */}
            </TextAlign>
          )}
          {/* {caseObj?.resolutionKind !== "arbitration" && (
            <li>
              Success Fee -{" "}
              <b
                style={{
                  fontFamily: `${theme.fonts.primaryFontExtraBold}`,
                }}
              >
                {negotiationSuccessFee?.unit}{" "}
                {parseFloat(negotiationSuccessFee?.total).toFixed(2)}
              </b>
            </li>
          )} */}
          {caseObj?.resolutionKind === "arbitration" ? (
            <>
              <div style={{ marginTop: "5px" }} />
              {editFlag !== 1 && (
                <TextAlign style={{ fontStyle: "italic", fontSize: "13px" }}>
                  {/* * Case Filing Fee shall be paid now */}
                </TextAlign>
              )}
              <div style={{ marginTop: "5px" }} />
              <TextAlign style={{ fontStyle: "italic", fontSize: "13px" }}>
                {/* * Arbitration Fee shall be paid over stages. The Arbitration Fee
                is indicative and may change if the Respondent files a
                counterclaim */}
              </TextAlign>
            </>
          ) : (
            <TextAlign>
              {caseObj?.resolutionKind !== "arbitration" && (
                <>
                  {/* (If the case is{" "}
                  {caseObj?.resolutionKind === "negotiation"
                    ? "negotiated"
                    : caseObj?.resolutionKind === "mediation"
                      ? "mediated"
                      : "arbitrated"}{" "}
                  successfully you need to pay the Success Fee for getting the
                  settlement agreement) */}
                  <br />
                </>
              )}
              {/* (Claim amount, once submitted, may be changed only if feasible.
              Any difference in fee will need to be paid in such a case) */}
            </TextAlign>
          )}
        </>
      )}
      {/* {caseObj?.subscriptionKind === "adhoc" ? (
        <li>
          <b>
            You will also need to pay the{" "}
            {caseObj?.resolutionKind === "mediation"
              ? "mediator"
              : "arbitrator"}{" "}
            as per the terms agreed between the parties and the{" "}
            {caseObj?.resolutionKind === "mediation"
              ? "mediator"
              : "arbitrator"}
            . JustAct will not be responsible for any non-payment in this
            regard.
          </b>
        </li>
      ) : (
        ""
      )}
      {caseObj?.subscriptionKind === "adhoc" ? (
        <TextAlign>
          (Claim amount, once submitted, may be changed only if feasible. Any
          difference in fee will need to be paid in such a case)
        </TextAlign>
      ) : (
        ""
      )} */}
    </UnorderList>
  );
};

const TextAlign = styled.text`
  text-align: left;
`;

const TextColor = styled.text`
  font-family: ${theme.fonts.primaryFontBold};
  color: ${COLORS.COLOR_DARK};
`;

const UnorderList = styled.ul`
  padding: 0px 10px;
  & .data-row {
    display: flex;
    & .data-field {
      padding: 10px 0px;
      font-family: ${theme.fonts.primaryFontSemiBold};
      & .label {
        color: ${COLORS.INPUT_LABEL};
        font-size: 8px;
      }
      & .value {
        font-size: 10px;
      }
      &:nth-child(2) {
        margin-left: 20px;
      }
    }
    @media ${theme?.breakpoints?.sm_up} {
      & .data-field {
        & .label {
          color: ${COLORS.INPUT_LABEL};
          font-size: 10px;
        }
        & .value {
          font-size: 14px;
        }
        &:nth-child(2) {
          margin-left: 30px;
        }
      }
    }
  }
  & li {
    padding: 5px;
  }

  & .adhoc-pricing {
    text-align: center;
  }
`;
